/* eslint-disable import/no-anonymous-default-export */
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { Auth } from "shared/@auth/Auth";
import Loader from "shared/Loader";
import LoadingContainer from "shared/LoadingContainer";
import PagingControls from "shared/PagingControls";
import Table from "shared/Table";
import formatDate from "shared/@utils/formatDate";
import styles from "./index.module.css";
import RefundForm from "./RefundForm";
import Tabs from "./Tabs";
import { useMembership } from "./useMembership";

export default function ({ iboNumber, events }) {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const { hasPermission } = Auth.useContainer();
  const { records, loading, refresh } = useMembership({
    iboNumber,
    limit,
    page,
  });

  useEffect(() => {
    if (loading) {
      events.emit("refresh:start");
    } else {
      events.emit("refresh:end");
    }
  }, [loading]);

  // Listen for refresh events on mount and stop listening when unmounted.
  useEffect(() => {
    const listener = () => {
      refresh();
    };

    events.on("refresh", listener);

    return () => {
      events.removeListener("refresh", listener);
    };
  }, [refresh]);

  const [query, setQuery] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);

  const canUpdate = hasPermission("membership.transaction.update");

  // An IBO with no membership transactions (or a page past the last one)
  // has nothing at selectedIndex; rendering the detail panels anyway crashed
  // the whole lookup page. Same guard as the BSM and Digital Delivery tabs.
  const selected = records && records[selectedIndex];

  return (
    <div className={styles.container}>
      {records == null ? (
        <Loader />
      ) : (
        <>
          <LoadingContainer isLoading={loading}>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>CC</th>
                  <th>ACH</th>
                  <th>Status</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                {records.map((m, i) => {
                  return (
                    <tr
                      key={i}
                      onMouseDown={() => {
                        setSelectedIndex(i);
                      }}
                      className={classNames(styles.resultRow, {
                        [styles.selected]: selectedIndex === i,
                      })}
                    >
                      <td>{m.id}</td>
                      <td>{formatDate(m.date)}</td>
                      <td>{m.cc && m.cc !== -1 ? m.cc : <Empty />}</td>
                      <td>{m.ach && m.ach !== -1 ? m.ach : <Empty />}</td>
                      <td>{m.status}</td>
                      <td>{m.type}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <div className={styles.pagingControls}>
              <PagingControls
                page={page}
                limit={limit}
                onPageChange={setPage}
                onLimitChange={setLimit}
                disableNext={records.length === 0}
                disabled={loading}
              />
            </div>
          </LoadingContainer>

          {selected && (
            <div className={styles.formContainer}>
              {canUpdate && (
                <div className={styles.leftCol}>
                  <RefundForm iboNumber={iboNumber} transaction={selected} />
                </div>
              )}

              <div className={styles.rightCol}>
                <Tabs
                  selectedTab="details"
                  transaction={selected}
                  onTabChange={(tabName) => {
                    setQuery({ ...query, tab: tabName });
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export function Empty() {
  return <span className={styles.emptyPlaceholder}>---</span>;
}
